<template>
    <!-- 对话框 -->
    <el-dialog :visible.sync="show" :before-close="closeDialog" width="70%">

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">




            <el-table-column prop="name" label="领取司机">
            </el-table-column>


            <el-table-column prop="phone" label="司机电话">

            </el-table-column>


            <el-table-column prop="price" label="金额">
                <template slot-scope="scope">
                    {{scope.row.price}}元
                </template>
            </el-table-column>




            <el-table-column prop="distance" label="距离">
                <template slot-scope="scope">
                    {{scope.row.distance}}米
                </template>
            </el-table-column>

            <el-table-column prop="time.YmdHis" label="领取时间">
            </el-table-column>



        </el-table>


        <!-- 分页组件 -->
        <div style="text-align: right;">
            <el-pagination layout="prev, pager, next" :total="result_data_children.count" @current-change="pages_function">
            </el-pagination>
        </div>

        <div style="display: flex;justify-content: center">
            <el-button @click="closeDialog">关闭</el-button>
        </div>



    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            'isShow': Boolean,
            'data': ''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.search_data_children.positioning_reward_code=_this.data;

                _this.driverPositioningRewardRecordLists();

            },

        },
        data() {
            return {

                show: false,

                tableData: [],


                //翻页数据
                search_data_children: {
                    page: 1,
                    limit: 10,
                    positioning_reward_code:''
                },

                result_data_children: [],
                search_rules_children: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                },

            };
        },
        created() {

            _this = this;

        },
        methods: {

            // 获取钱包信息
            driverPositioningRewardRecordLists() {
                _this.$post(
                    '/driver/driverPositioningRewardRecordLists',
                    _this.search_data_children,
                    _this.search_rules_children
                )
                    .then(res => {

                        // 将获取到的数据赋值

                        _this.tableData = res.data;
                        _this.result_data_children=res;



                    }).catch((err) => {

                })
            },
            // 关闭方法
            closeDialog() {

                _this.show = false;


            },

            //翻页组件的回调
            pages_function(val) {
                _this.search_data_children.page = val;

                //初始化列表
                _this.driverPositioningRewardRecordLists();

            },

        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
</style>